// 観察記録の入力欄の部品

// react moment
import * as React from 'react';
// material-ui
import Button from '@material-ui/core/Button';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import { Typography, Radio, RadioGroup, FormControlLabel, FormControl, FormLabel } from '@material-ui/core';
// CSS
import './InferenceResultView.css';
// models
import { KansatsuKirokuObsrec } from '../../models/KansatsuKirokuObsrec';
import { InferenceResultSubdiv } from '../../models/InferenceResultSubdiv';
import { InferenceAdditionalResultSubdiv } from '../../models/InferenceAdditionalResultSubdiv';
import { SiteInfo } from '../../models/SiteInfo';

// 岩石グループ定義 (EditKansatsuKirokuSubdivPage.tsx からも参照するため export する)
export const ROCK_MASS_GROUPS = [
  { id: 'MASSIVE_HARD_ROCK', name: '【塊状】硬質岩' },
  { id: 'MASSIVE_MEDIUM_SOFT_ROCK', name: '【塊状】中硬質岩・軟硬質岩' },
  { id: 'LAYERED_MEDIUM_ROCK', name: '【層状】中硬質岩' },
  { id: 'LAYERED_SOFT_ROCK', name: '【層状】軟硬質岩' },
];
export const DEFAULT_ROCK_MASS_GROUP_ID = ROCK_MASS_GROUPS[0].id; // デフォルトは「【塊状】硬質岩」

const styles = {
  valueField: {
    width: '150px',
    marginRight: '5px'
  },
  rowDark: {
    fontSize: '15px',
    backgroundColor: '#3f51b514',
    padding: '0px',
    textAlign: "center" as "center"
  },
  rowLight: {
    fontSize: '15px',
    padding: '0px',
    textAlign: "center" as "center"
  },
};

interface OwnProps {
  disabled: boolean;
  data: KansatsuKirokuObsrec['observationsScores'];
  orgdata: KansatsuKirokuObsrec['observationsScores'];
  // trueの場合ボタンを非表示にする（主に印刷時）
  lineNum: number;
  columnNum: number;
  observationNames: string[];
  observationDescriptions: string[]

  result: InferenceResultSubdiv[];
  additionalResult: InferenceAdditionalResultSubdiv;
  // 結果表を非表示にする（主に印刷用）
  hideTable?: boolean;
  // 画像を非表示にする（主に印刷用）
  hideImages?: boolean;
  // 印刷時の描写か（主に印刷用）未指定の場合は undefined となり、判定では false つまりデフォルト値は false
  isPrint?: boolean;
  cropImageWidth: number;
  rockMassGroup?: string; // 親コンポーネントから渡される初期値または更新値 (Optionalに変更)

  // 評価値確定がステップルールの場合に必要な要素
  targetStepRuleObservationNames?: string[];
  // 評価値確定が最頻値ルールの場合に必要な要素
  targetModeRuleObservationNames?: string[];
  // 評価値確定が平均<スコア重複排除前提>ルールの場合に必要な要素
  targetMeanDeduplicationRuleObservationNames?: string[];
  // 評価値確定が平均<一般>ルールの場合に必要な要素
  targetMeanGeneralRuleObservationNames?: string[];

  topBadsideSize?: number;
  leftBadsideSize?: number;
  rightBadsideSize?: number;

  // 切羽評価点テーブル用に追加
  excavationFaceScoreConversionTableData?: SiteInfo['excavationFaceScoreConversionTableData'];
  observationMap?: SiteInfo['observationMap'];
  isIncludeInSubtotalObservations?: SiteInfo['isIncludeInSubtotalObservations'];
  isIncludeInTotalObservations?: SiteInfo['isIncludeInTotalObservations'];

  // 岩石グループ変更時に親コンポーネントに通知するためのコールバック
  onRockMassGroupChanged?: (group: string) => void; // (Optionalに変更)

}
interface OwnState {
  // 入力項目に対するState 「KansatsuKirokuObsrec['observationsScores']」と同じ型
  observationsScores: Array<{
    observation: string; // 観察項目
    scores: Array<{
      position: string; // 位置（左上から右方向でカウントしたときの位置）
      score: string; // スコア
    }>;
  }>,
  resultHuman: InferenceResultSubdiv[]; // 人判断のresult(人判断の総合評価用)
  additionalResultHuman: InferenceAdditionalResultSubdiv; // 人判断のadditionalResult(人判断の総合評価用)
  selectedRockMassGroup: string; // 選択された岩石グループのID (必須に変更)
}

class KansatsuKirokuScoreEditForSubdiv extends React.Component<OwnProps, OwnState>{
  constructor(props: OwnProps) {
    super(props);
    // --- デバッグログ追加 (Constructor) ---
    // console.log("KansatsuKirokuScoreEditForSubdiv Constructor called.");
    // console.log("  Initial props.rockMassGroup:", props.rockMassGroup);
    const initialRockMassGroup = props.rockMassGroup || DEFAULT_ROCK_MASS_GROUP_ID;
    // console.log("  Setting initial state.selectedRockMassGroup to:", initialRockMassGroup);
    // --- デバッグログ追加ここまで ---
    this.state = {
      observationsScores: [],
      resultHuman: [],
      additionalResultHuman: {
        each_position_score: { left: 0, top: 0, right: 0 },
        each_position_weight: { left: 0, top: 0, right: 0 },
        finally_score: 0
      },
      selectedRockMassGroup: initialRockMassGroup, // ログで確認した値を使用
    };
    this.handleRockMassGroupChange = this.handleRockMassGroupChange.bind(this);
  }

  componentWillReceiveProps(newProps: OwnProps) {
    // --- デバッグログ追加 (componentWillReceiveProps) ---
    if (newProps.rockMassGroup !== this.props.rockMassGroup) {
      // console.log("KansatsuKirokuScoreEditForSubdiv componentWillReceiveProps detected rockMassGroup change.");
      // console.log("  Current props.rockMassGroup:", this.props.rockMassGroup);
      // console.log("  New props.rockMassGroup:", newProps.rockMassGroup);
      // console.log("  Updating state.selectedRockMassGroup to:", nextRockMassGroup);
    }
    // --- デバッグログ追加ここまで ---

    if (newProps.data !== this.props.data || (newProps.data && newProps.data.length === 0 && this.state.observationsScores.length === 0)) {
      const obsScoresToSet = newProps.data || this.initializeScores(newProps);
      this.setState({ observationsScores: obsScoresToSet }, () => {
        this.changeComprehensiveEvaluationTable();
      });
    }

    if (newProps.rockMassGroup !== this.props.rockMassGroup && newProps.rockMassGroup) {
      this.setState({
        selectedRockMassGroup: newProps.rockMassGroup || DEFAULT_ROCK_MASS_GROUP_ID
      }, () => {
        if (this.state.observationsScores && this.state.observationsScores.length > 0) {
          this.changeComprehensiveEvaluationTable();
        }
      });
    } else if (this.state.observationsScores && this.state.observationsScores.length > 0 && !this.props.result){
      this.changeComprehensiveEvaluationTable();
    }
  }

  initializeScores(props: OwnProps): OwnState['observationsScores'] {
    const observationsScoresInitialScore: OwnState['observationsScores'] = [];
    const obsNames = props.observationNames || [];
    if (props.lineNum && props.columnNum) {
      for (const obsName of obsNames) {
        const obsElement: { observation: string; scores: Array<{ position: string; score: string; }> } = { observation: obsName, scores: [] };
        for (let i2 = 0; i2 < props.lineNum; i2++) {
          for (let i3 = 0; i3 < props.columnNum; i3++) {
            const positionStr: string = String(i2 + 1) + '-' + String(i3 + 1);
            obsElement.scores.push({ position: positionStr, score: '0' });
          }
        }
        observationsScoresInitialScore.push(obsElement);
      }
    }
    return observationsScoresInitialScore;
  }

  getSum(list: any[]): number {
    let sum = 0;
    list.forEach((elm) => {
      sum += elm;
    });
    return sum;
  };

  getMean(list: any[]): number {
    const listExcZero = list.filter(item => item > 0);
    return this.getSum(listExcZero) / listExcZero.length;
  };

  getMode(list: any[]): number {
    if (list.length === 0) { // 配列の個数が0だとエラーを返す。
      // throw new Error("配列の長さが0のため最頻値が計算できません");
      return 0 // nullを返しても困らない時(配列の中にnullが無い時)はnullを返すように実装しても良い。
    }
    const counter = {} // 回数を記録する連想配列
    const nativeValues = {} // 本来の値を入れた辞書
    // 最頻値とその出現回数を挿入する変数
    let maxCounter = 0;
    let maxValue = 0;
    for (const item of list) {
      if (!counter[item + "_" + typeof item]) { // counterに存在しなければ作る。keyは型を区別する
        counter[item + "_" + typeof item] = 0;
      }
      counter[item + "_" + typeof item]++;
      nativeValues[item + "_" + typeof item] = item;
    }
    // 最頻値が同数であれば小さい数字を採用
    let counterTmp = Object.keys(counter).map((k) => ({ key: k, value: counter[k] }));
    let nativeValuesTep = Object.keys(nativeValues).map((k) => ({ key: k, value: nativeValues[k] }));
    counterTmp = counterTmp.sort((a: any, b: any) => a.key > b.key ? 1 : -1);
    nativeValuesTep = nativeValuesTep.sort((a: any, b: any) => a.key > b.key ? 1 : -1);

    const counter2 = counterTmp.reduce((acc, item) => { acc[item.key] = item.value; return acc; }, {});
    const nativeValues2 = nativeValuesTep.reduce((acc, item) => { acc[item.key] = item.value; return acc; }, {});
    for (const key of Object.keys(counter2)) {
      if (counter2[key] >= maxCounter) {  // 最頻値が同数の場合に小さい数値を優先する場合は > 、大きい数値を優先する場合は >=
        maxCounter = counter2[key];
        maxValue = nativeValues2[key]
      }
    }
    return maxValue
  }

  getStepRuleScore(list: any[], badsideSize: any): number {
    const deduplicationList = Array.from(new Set(list));
    if(!badsideSize){
      return Math.round(this.getMean(deduplicationList))
    }
    const tmpList = list.filter(item => item > 0); // 該当領域のスコア群から0を除外する
    const maxScore = Math.max.apply(null, tmpList);
    const maxScoreCount = tmpList.filter(n => n === maxScore).length;
    if (maxScoreCount >= badsideSize){
      return maxScore
    }else{
      return Math.round(this.getMean(deduplicationList))
    }
  }
  getMeanDeduplicationRuleScore(list: any[]): number {
    const deduplicationList = Array.from(new Set(list));
    return Math.round(this.getMean(deduplicationList))
  }
  getMeanGeneralRuleScore(list: any[]): number {
    return Math.round(this.getMean(list))
  }

  changeComprehensiveEvaluationTable() { // 人判断の総合評価表の更新
    if (this.props.result) {
      let resultHumanTmp: InferenceResultSubdiv[] = []
      resultHumanTmp = JSON.parse(JSON.stringify(this.props.result)) // 最下層まで複製
      const obsNums: number[] = []
      for (const key of Object.keys(resultHumanTmp)) {
        obsNums.push(parseInt(key, 10))
      }

      // 天端のリストを作成
      const topPositionList: string[] = []
      for (let rowNum = 0; rowNum < this.props.lineNum / 2; rowNum++) {
        for (let colNum = 0; colNum < this.props.columnNum; colNum++) {
          const positionStr = String(Number(rowNum + 1)) + '-' + String(Number(colNum + 1))
          topPositionList.push(positionStr)
        }
      }
      // 左肩のリストを作成
      const leftPositionList: string[] = []
      for (let rowNum = this.props.lineNum / 2; rowNum < this.props.lineNum; rowNum++) {
        for (let colNum = 0; colNum < this.props.columnNum / 2; colNum++) {
          const positionStr = String(Number(rowNum + 1)) + '-' + String(Number(colNum + 1))
          leftPositionList.push(positionStr)
        }
      }
      // 右肩のリストを作成
      const rightPositionList: string[] = []
      for (let rowNum = this.props.lineNum / 2; rowNum < this.props.lineNum; rowNum++) {
        for (let colNum = this.props.columnNum / 2; colNum < this.props.columnNum; colNum++) {
          const positionStr = String(Number(rowNum + 1)) + '-' + String(Number(colNum + 1))
          rightPositionList.push(positionStr)
        }
      }

      for (let i1 = 0; i1 < obsNums.length; i1++) { // 観察項目ごとに繰り返し
        if (!this.state.observationsScores[i1]) {
          console.warn(`observationsScores[${i1}] is undefined. Skipping calculation for this item.`);
          continue; // Skip to the next iteration if the data is missing
        }
        resultHumanTmp[i1].result_score = {
          left: { mode: '', mean: '' },
          top: { mode: '', mean: '' },
          right: { mode: '', mean: '' }
        };
      }

      // let resultHumanTmpTmp = JSON.parse(JSON.stringify(this.state.resultHumanTmp))
      // 天端のリストを作成
      const additionalTopScoreTmp: number[] = []
      const additionalLeftScoreTmp: number[] = []
      const additionalRightScoreTmp: number[] = []
      for (let i1 = 0; i1 < obsNums.length; i1++) {
        if (!this.state.observationsScores[i1]) {
          continue; // Skip calculation if observationsScores[i1] is missing
        }
        let topModeScore = 0
        let leftModeScore = 0
        let rightModeScore = 0
        // 天端
        const topPositionScoreList: number[] = []
        for (const topPosition of topPositionList) {
          if (this.state.observationsScores[i1].scores) {
            for (const score of this.state.observationsScores[i1].scores) {
              if (score.position === topPosition) {
                topPositionScoreList.push(parseInt(score.score, 10))
              }
            }
          }
        }
        resultHumanTmp[i1].result_score.top.mean = String(Math.round(10 * this.getMean(topPositionScoreList)) / 10)
        if (this.props.targetStepRuleObservationNames && this.props.targetStepRuleObservationNames.indexOf(resultHumanTmp[i1].observation_name) !== -1){
          // ステップルール
          topModeScore = this.getStepRuleScore(topPositionScoreList, this.props.topBadsideSize)
        }else if (this.props.targetModeRuleObservationNames && this.props.targetModeRuleObservationNames.indexOf(resultHumanTmp[i1].observation_name) !== -1){
          // 最頻値ルール
          topModeScore = this.getMode(topPositionScoreList)
        }else if (this.props.targetMeanDeduplicationRuleObservationNames && this.props.targetMeanDeduplicationRuleObservationNames.indexOf(resultHumanTmp[i1].observation_name) !== -1){
          // 平均<スコア重複排除前提>ルール
          topModeScore = this.getMeanDeduplicationRuleScore(topPositionScoreList)
        }else if (this.props.targetMeanGeneralRuleObservationNames && this.props.targetMeanGeneralRuleObservationNames.indexOf(resultHumanTmp[i1].observation_name) !== -1){
          // 平均<一般>ルール
          topModeScore = this.getMeanGeneralRuleScore(topPositionScoreList)
        }else{
          topModeScore = this.getMode(topPositionScoreList)
        }
        resultHumanTmp[i1].result_score.top.mode = String(topModeScore)
        additionalTopScoreTmp.push(resultHumanTmp[i1].weight * topModeScore / 100)
        // 左肩
        const leftPositionScoreList: number[] = []
        for (const leftPosition of leftPositionList) {
          if (this.state.observationsScores[i1].scores) {
            for (const score of this.state.observationsScores[i1].scores) {
              if (score.position === leftPosition) {
                leftPositionScoreList.push(parseInt(score.score, 10))
              }
            }
          }
        }
        resultHumanTmp[i1].result_score.left.mean = String(Math.round(10 * this.getMean(leftPositionScoreList)) / 10)
        if (this.props.targetStepRuleObservationNames && this.props.targetStepRuleObservationNames.indexOf(resultHumanTmp[i1].observation_name) !== -1){
          // ステップルール
          leftModeScore = this.getStepRuleScore(leftPositionScoreList, this.props.leftBadsideSize)
        }else if (this.props.targetModeRuleObservationNames && this.props.targetModeRuleObservationNames.indexOf(resultHumanTmp[i1].observation_name) !== -1){
          // 最頻値ルール
          leftModeScore = this.getMode(leftPositionScoreList)
        }else if (this.props.targetMeanDeduplicationRuleObservationNames && this.props.targetMeanDeduplicationRuleObservationNames.indexOf(resultHumanTmp[i1].observation_name) !== -1){
          // 平均<スコア重複排除前提>ルール
          leftModeScore = this.getMeanDeduplicationRuleScore(leftPositionScoreList)
        }else if (this.props.targetMeanGeneralRuleObservationNames && this.props.targetMeanGeneralRuleObservationNames.indexOf(resultHumanTmp[i1].observation_name) !== -1){
          // 平均<一般>ルール
          leftModeScore = this.getMeanGeneralRuleScore(leftPositionScoreList)
        }else{
          leftModeScore = this.getMode(leftPositionScoreList)
        }
        resultHumanTmp[i1].result_score.left.mode = String(leftModeScore)
        additionalLeftScoreTmp.push(resultHumanTmp[i1].weight * leftModeScore / 100)

        // 右肩
        const rightPositionScoreList: number[] = []
        for (const rightPosition of rightPositionList) {
          if (this.state.observationsScores[i1].scores) {
            for (const score of this.state.observationsScores[i1].scores) {
              if (score.position === rightPosition) {
                rightPositionScoreList.push(parseInt(score.score, 10))
              }
            }
          }
        }
        resultHumanTmp[i1].result_score.right.mean = String(Math.round(10 * this.getMean(rightPositionScoreList)) / 10)
        if (this.props.targetStepRuleObservationNames && this.props.targetStepRuleObservationNames.indexOf(resultHumanTmp[i1].observation_name) !== -1){
          // ステップルール
          rightModeScore = this.getStepRuleScore(rightPositionScoreList, this.props.rightBadsideSize)
        }else if (this.props.targetModeRuleObservationNames && this.props.targetModeRuleObservationNames.indexOf(resultHumanTmp[i1].observation_name) !== -1){
          // 最頻値ルール
          rightModeScore = this.getMode(rightPositionScoreList)
        }else if (this.props.targetMeanDeduplicationRuleObservationNames && this.props.targetMeanDeduplicationRuleObservationNames.indexOf(resultHumanTmp[i1].observation_name) !== -1){
          // 平均<スコア重複排除前提>ルール
          rightModeScore = this.getMeanDeduplicationRuleScore(rightPositionScoreList)
        }else if (this.props.targetMeanGeneralRuleObservationNames && this.props.targetMeanGeneralRuleObservationNames.indexOf(resultHumanTmp[i1].observation_name) !== -1){
          // 平均<一般>ルール
          rightModeScore = this.getMeanGeneralRuleScore(rightPositionScoreList)
        }else{
          rightModeScore = this.getMode(rightPositionScoreList)
        }
        resultHumanTmp[i1].result_score.right.mode = String(rightModeScore)
        additionalRightScoreTmp.push(resultHumanTmp[i1].weight * rightModeScore / 100)
      }
      // 左肩、天端、右肩ごとのスコアを算出
      const additionalTopScore = Math.round(10 * this.getSum(additionalTopScoreTmp)) / 10
      const additionalLeftScore = Math.round(10 * this.getSum(additionalLeftScoreTmp)) / 10
      const additionalRightScore = Math.round(10 * this.getSum(additionalRightScoreTmp)) / 10
      const finallyScore = Math.round(10 * this.getSum([additionalTopScore * 2 , additionalLeftScore, additionalRightScore]) / 4) / 10

      this.setState({
        resultHuman: resultHumanTmp,
        additionalResultHuman: {
          each_position_score: { left: additionalLeftScore, top: additionalTopScore, right: additionalRightScore },
          each_position_weight: { left: 1, top: 2, right: 1 },
          finally_score: finallyScore
        }
      });
    }
  };

  /**
   * 外部から値を取得する
   */
  get() {
    return {
      observationsScores: this.state.observationsScores,
      resultHuman: this.state.resultHuman,
      additionalResultHuman: this.state.additionalResultHuman,
      selectedRockMassGroup: this.state.selectedRockMassGroup // 選択された岩石グループIDを追加
    };
  }

  calcImgZoom() {
    const obsNum = this.props.result.length
    let yokoImgNum = 0
    if (obsNum <= 4) {
      yokoImgNum = 2
    } else if (obsNum <= 6) {
      yokoImgNum = 3
    } else if (obsNum <= 12) {
      yokoImgNum = 4
    } else {
      yokoImgNum = 5
    }
    let zoom = 0
    if (yokoImgNum === 2) {
      zoom = Math.round(((1024 - 100 - 50 * 2 - 10 * (2 + yokoImgNum - 1)) * 100 / yokoImgNum) / this.props.cropImageWidth)  // 1024pxはA4の横幅px 50px両側マージンを考慮する -100 は微調整
    } else {
      zoom = Math.round(((1024 - 50 * 2 - 10 * (2 + yokoImgNum - 1)) * 100 / yokoImgNum) / this.props.cropImageWidth)  // 1024pxはA4の横幅px 50px両側マージンを考慮する
    }
    // console.log(zoom)
    return String(zoom) + '%'
  }

  // ラジオボタン変更ハンドラ
  handleRockMassGroupChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newGroup = event.target.value;
    this.setState({ selectedRockMassGroup: newGroup }, () => {
      // 変更を親コンポーネントに通知する (コールバックが存在すれば)
      if (this.props.onRockMassGroupChanged) {
        this.props.onRockMassGroupChanged(newGroup);
      }
      // 変更後の岩石グループで切羽評価点を再計算
      // changeComprehensiveEvaluationTableはrender内で呼ばれるので不要かもしれないが、念のため呼ぶ
      this.changeComprehensiveEvaluationTable();
    });
  };

  // --- Helper functions for Excavation Face Score Table ---
  /**
   * 観察項目キー、岩石グループ、元のスコアから変換後のスコアを取得する
   * @param observationKey 観察項目キー (例: 'a', 'b')
   * @param rockGroup 岩石グループID
   * @param originalScoreStr 元のスコア (文字列)
   * @returns 変換後のスコア、見つからない場合や評価不能(-1)の場合は -1
   */
  getConvertedScore(observationKey: string, rockGroup: string, originalScoreStr: string): number {
    const originalScore = parseInt(originalScoreStr, 10);
    if (isNaN(originalScore) || originalScore < 0 || originalScore > 6) {
      return -1; // 不正なスコア
    }

    const conversionTable = this.props.excavationFaceScoreConversionTableData;
    if (!conversionTable || !observationKey || !rockGroup) {
      return -1; // 変換テーブルやキーがない
    }

    const entry = conversionTable.find(
      (item) => item.observation === observationKey && item.rock_group === rockGroup
    );

    if (!entry) {
      return -1; // 対応する変換ルールがない
    }

    const gradeKey = `eval_grade_${originalScore}` as keyof typeof entry;
    const convertedScore = entry[gradeKey];

    // convertedScore が number 型であることを確認し、そうでない場合は -1 を返す
    if (typeof convertedScore !== 'number') {
        return -1;
    }

    return convertedScore;
  }

  /**
   * 左肩、天端、右肩のスコアから加重平均を計算する
   * @param left 左肩スコア
   * @param top 天端スコア
   * @param right 右肩スコア
   * @returns 加重平均 (小数点第2位で四捨五入)、計算不能なスコアが含まれる場合は NaN
   */
  calculateWeightedAverage(left: number, top: number, right: number): number {
    // スコアが-1の場合は計算不能とする
    if (left === -1 || top === -1 || right === -1) {
      return NaN;
    }
    const weightedSum = left + top * 2 + right;
    const average = weightedSum / 4;
    return Math.round(average * 10) / 10;
  }
  // --- End Helper functions ---

  render() {
    if (!this.props.result || !(this.props.result.length > 0)) {
      return (<Typography variant="body2">データ無し</Typography>);
    }

    // AI診断 追加評価情報
    const additionalLeft = (this.props.additionalResult.each_position_score || {}).left;
    const additionalTop = (this.props.additionalResult.each_position_score || {}).top;
    const additionalRight = (this.props.additionalResult.each_position_score || {}).right;
    const finallyScore = this.props.additionalResult.finally_score;
    // 人判断 追加評価情報
    // console.log(this.state.additionalResultHuman.each_position_score)
    const additionalLeftHuman = (this.state.additionalResultHuman.each_position_score || {}).left;
    const additionalTopHuman = (this.state.additionalResultHuman.each_position_score || {}).top;
    const additionalRightHuman = (this.state.additionalResultHuman.each_position_score || {}).right;
    const finallyScoreHuman = this.state.additionalResultHuman.finally_score;

    // --- 切羽評価点テーブルの計算 ---
    const excavationFaceScores: Array<{
      observationKey: string;
      observationName: string;
      left: number;
      top: number;
      right: number;
      average: number | string; // NaN の可能性があるので string も含む
    }> = [];

    const observationMap = this.props.observationMap || {};
    // observationMap の逆引きマップを作成 (value: key)
    const reverseObservationMap: { [key: string]: string } = {};
    for (const key in observationMap) {
      if (Object.prototype.hasOwnProperty.call(observationMap, key)) {
        reverseObservationMap[observationMap[key]] = key;
      }
    }

    // --- デバッグログ追加 ---
    // console.log("Calculating excavationFaceScores...");
    // console.log("this.state.resultHuman:", this.state.resultHuman);
    // console.log("this.props.excavationFaceScoreConversionTableData:", this.props.excavationFaceScoreConversionTableData);
    // console.log("this.state.selectedRockMassGroup:", this.state.selectedRockMassGroup);
    // console.log("reverseObservationMap:", reverseObservationMap);
    // --- デバッグログ追加ここまで ---

    if (this.state.resultHuman && this.props.excavationFaceScoreConversionTableData && this.state.selectedRockMassGroup) {
      this.state.resultHuman.forEach(item => {
        const observationName = item.observation_name;
        const observationKey = reverseObservationMap[observationName]; // マップからキーを取得

        if (observationKey && item.result_score) {
          const leftScoreStr = (item.result_score.left && item.result_score.left.mode) ? item.result_score.left.mode : '-1';
          const topScoreStr = (item.result_score.top && item.result_score.top.mode) ? item.result_score.top.mode : '-1';
          const rightScoreStr = (item.result_score.right && item.result_score.right.mode) ? item.result_score.right.mode : '-1';

          const convertedLeft = this.getConvertedScore(observationKey, this.state.selectedRockMassGroup, leftScoreStr);
          const convertedTop = this.getConvertedScore(observationKey, this.state.selectedRockMassGroup, topScoreStr);
          const convertedRight = this.getConvertedScore(observationKey, this.state.selectedRockMassGroup, rightScoreStr);
          const weightedAverage = this.calculateWeightedAverage(convertedLeft, convertedTop, convertedRight);

          // --- デバッグログ追加 ---
          // console.log(`  Observation: ${observationKey}, L/T/R (Original): ${leftScoreStr}/${topScoreStr}/${rightScoreStr}, L/T/R (Converted): ${convertedLeft}/${convertedTop}/${convertedRight}, Average: ${weightedAverage}`);
          // --- デバッグログ追加ここまで ---

          excavationFaceScores.push({
            observationKey,
            observationName,
            left: convertedLeft,
            top: convertedTop,
            right: convertedRight,
            average: isNaN(weightedAverage) ? '-' : weightedAverage.toFixed(1),
          });
        }
      });
    }

    // 小計と合計の計算
    const calculateTotals = (keysToInclude?: string[]) => {
      let totalLeft = 0;
      let totalTop = 0;
      let totalRight = 0;

      excavationFaceScores.forEach(score => {
        if (!keysToInclude || keysToInclude.includes(score.observationKey)) {
          if (score.left !== -1) {
            totalLeft += score.left;
          }
          if (score.top !== -1) {
            totalTop += score.top;
          }
          if (score.right !== -1) {
            totalRight += score.right;
          }
        }
      });
      // 合計値から加重平均を再計算
      const totalAverage = this.calculateWeightedAverage(totalLeft, totalTop, totalRight);

      return {
        left: totalLeft,
        top: totalTop,
        right: totalRight,
        average: isNaN(totalAverage) ? ' ' : totalAverage.toFixed(1),
      };
    };

    const subtotalKeys = this.props.isIncludeInSubtotalObservations || [];
    const totalKeys = this.props.isIncludeInTotalObservations || [];

    const subTotals = subtotalKeys.length > 0 ? calculateTotals(subtotalKeys) : null;
    const totals = totalKeys.length > 0 ? calculateTotals(totalKeys) : null;
    // --- ここまで計算 ---

    // console.log("KansatsuKirokuScoreEditForSubdiv をレンダリング中 selectedRockMassGroup state:", this.state.selectedRockMassGroup);

    return (
      <div style={this.props.isPrint ? { width: '100%', display: 'flex', flexWrap: 'wrap', margin: '10px', breakBefore: 'page' } : {}}>
        {/* 画像表示部分 */}
        {!this.props.hideImages && this.props.result.map((item, index) => {
          const url = item.overlay_img_presigned_url;
          return (
            <div key={`images_${index}`} style={this.props.isPrint ? { display: 'flex', flexDirection: 'column', margin: '10px', zoom: this.calcImgZoom() } : {}}>
              <Typography variant="h6">{item.observation_name}</Typography>
              <Typography variant="h6">{this.props.observationDescriptions[index]}</Typography>
              {
                (url)
                  ? <img src={url} style={this.props.isPrint ? {} : { maxWidth: '100%', marginRight: 'auto' }} />
                  : <span>画像なし</span>
              }
              {(this.props.orgdata[index]) && (
                <div style={this.props.isPrint ? { width: this.props.cropImageWidth, display: 'flex', flexDirection: 'column' } : { width: this.props.cropImageWidth, marginTop: '10px', marginBottom: '10px' }}>
                  {this.renderScoreInputObservationArea(this.state.observationsScores[index], this.props.orgdata[index], index)}
                </div>
              )}
            </div>
          );
        })}

        {!this.props.isPrint && <hr />}

        {/* テーブル表示部分 */}
        {!this.props.hideTable && (
          <div>
            <Typography variant="h6">AI診断による総合評価</Typography>
            <table style={{ width: '100%', borderCollapse: 'collapse' }} className="inferenceresulttable">
              <thead>
                <tr>
                  <th>観察項目</th>
                  <th style={{ width: '90px' }}>重み係数</th>
                  <th style={{ width: '90px' }}>左肩</th>
                  <th style={{ width: '90px' }}>天端</th>
                  <th style={{ width: '90px' }}>右肩</th>
                </tr>
              </thead>
              <tbody>
                {
                  this.props.result.map((item, index) => {
                    const scoreLeft = (item.result_score && item.result_score.left)
                      ? `${item.result_score.left.mode}` : '';
                    const scoreTop = (item.result_score && item.result_score.top)
                      ? `${item.result_score.top.mode}` : '';
                    const scoreRight = (item.result_score && item.result_score.right)
                      ? `${item.result_score.right.mode}` : '';
                    return (<tr key={`item_${index}`} className={(index % 2 === 0) ? 'even' : ''}>
                      <td>{item.observation_name}</td>
                      <td style={{ textAlign: 'center' }}>{item.weight}</td>
                      <td style={{ textAlign: 'center' }}>{scoreLeft}</td>
                      <td style={{ textAlign: 'center' }}>{scoreTop}</td>
                      <td style={{ textAlign: 'center' }}>{scoreRight}</td>
                    </tr>);
                  })
                }
                <tr style={{ borderTop: 'solid 3px black' }}>
                  <th colSpan={2} style={{ textAlign: 'right' }}>左肩、天端、右肩の総合評価点</th>
                  <td style={{ textAlign: 'center' }}>{additionalLeft}</td>
                  <td style={{ textAlign: 'center' }}>{additionalTop}</td>
                  <td style={{ textAlign: 'center' }}>{additionalRight}</td>
                </tr>
                <tr>
                  <th colSpan={2} style={{ textAlign: 'right' }}>切羽全体の評価点</th>
                  <td style={{ textAlign: 'center' }} colSpan={3}>{finallyScore}</td>
                </tr>
              </tbody>
            </table>
            <br />

            {/* 人判断の総合評価表 */}
            {this.state.resultHuman.length > 0 && (
              <div>
                <Typography variant="h6">修正を加味した総合評価</Typography>
                <table style={{ width: '100%', borderCollapse: 'collapse' }} className="inferenceresulttable">
                  <thead>
                    <tr>
                      <th>観察項目</th>
                      <th style={{ width: '90px' }}>重み係数</th>
                      <th style={{ width: '90px' }}>左肩</th>
                      <th style={{ width: '90px' }}>天端</th>
                      <th style={{ width: '90px' }}>右肩</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      this.state.resultHuman.map((item, index) => {
                        const scoreLeft = (item.result_score && item.result_score.left)
                          ? `${item.result_score.left.mode}` : '';
                        const scoreTop = (item.result_score && item.result_score.top)
                          ? `${item.result_score.top.mode}` : '';
                        const scoreRight = (item.result_score && item.result_score.right)
                          ? `${item.result_score.right.mode}` : '';
                        return (<tr key={`item_${index}`} className={(index % 2 === 0) ? 'even' : ''}>
                          <td>{item.observation_name}</td>
                          <td style={{ textAlign: 'center' }}>{item.weight}</td>
                          <td style={{ textAlign: 'center' }}>{scoreLeft}</td>
                          <td style={{ textAlign: 'center' }}>{scoreTop}</td>
                          <td style={{ textAlign: 'center' }}>{scoreRight}</td>
                        </tr>);
                      })
                    }
                    <tr style={{ borderTop: 'solid 3px black' }}>
                      <th colSpan={2} style={{ textAlign: 'right' }}>左肩、天端、右肩の総合評価点</th>
                      <td style={{ textAlign: 'center' }}>{additionalLeftHuman}</td>
                      <td style={{ textAlign: 'center' }}>{additionalTopHuman}</td>
                      <td style={{ textAlign: 'center' }}>{additionalRightHuman}</td>
                    </tr>
                    <tr>
                      <th colSpan={2} style={{ textAlign: 'right' }}>切羽全体の評価点</th>
                      <td style={{ textAlign: 'center' }} colSpan={3}>{finallyScoreHuman}</td>
                    </tr>
                  </tbody>
                </table>
                <br />

                {/* 岩石グループ選択 - Ensure value uses state */}
                <FormControl style={{ marginTop: '20px', marginBottom: '20px' }} disabled={this.props.disabled}>
                  <FormLabel><Typography variant="h6">岩石グループ選択</Typography></FormLabel>
                  <RadioGroup
                    aria-label="rock-mass-group"
                    name="rock-mass-group"
                    value={this.state.selectedRockMassGroup}
                    onChange={this.handleRockMassGroupChange}
                    row
                  >
                    {ROCK_MASS_GROUPS.map((group) => (
                      <FormControlLabel
                        key={group.id}
                        value={group.id}
                        control={<Radio color="primary" />}
                        label={group.name}
                      />
                    ))}
                  </RadioGroup>
                </FormControl>

                {/* 切羽評価点テーブル */}
                <Typography variant="h6">切羽評価点</Typography>
                <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '20px' }} className="inferenceresulttable">
                  <thead>
                    <tr>
                      <th>観察項目</th>
                      <th style={{ width: '90px' }}>左肩</th>
                      <th style={{ width: '90px' }}>天端</th>
                      <th style={{ width: '90px' }}>右肩</th>
                      <th style={{ width: '90px' }}>加重平均</th>
                    </tr>
                  </thead>
                  <tbody>
                    {excavationFaceScores.map((item, index) => (
                      <tr key={`efs_item_${index}`} className={(index % 2 === 0) ? 'even' : ''}>
                        <td>{`${item.observationKey}. ${observationMap[item.observationKey] || item.observationName}`}</td>
                        <td style={{ textAlign: 'center' }}>{item.left === -1 ? ' ' : item.left}</td>
                        <td style={{ textAlign: 'center' }}>{item.top === -1 ? ' ' : item.top}</td>
                        <td style={{ textAlign: 'center' }}>{item.right === -1 ? ' ' : item.right}</td>
                        <td style={{ textAlign: 'center' }}>{item.average}</td>
                      </tr>
                    ))}
                    {/* 小計行 */}
                    {subTotals && (
                      <tr style={{ borderTop: 'solid 1px gray' }}>
                        <th style={{ textAlign: 'left' }}>{`${subtotalKeys.join(', ')} の合計`}</th>
                        <td style={{ textAlign: 'center' }}>{subTotals.left}</td>
                        <td style={{ textAlign: 'center' }}>{subTotals.top}</td>
                        <td style={{ textAlign: 'center' }}>{subTotals.right}</td>
                        <td style={{ textAlign: 'center' }}>{subTotals.average}</td>
                      </tr>
                    )}
                    {/* 合計行 */}
                    {totals && (
                      <tr style={{ borderTop: 'solid 1px gray' }}>
                        <th style={{ textAlign: 'left' }}>{`${totalKeys.join(', ')} の合計`}</th>
                        <td style={{ textAlign: 'center' }}>{totals.left}</td>
                        <td style={{ textAlign: 'center' }}>{totals.top}</td>
                        <td style={{ textAlign: 'center' }}>{totals.right}</td>
                        <td style={{ textAlign: 'center' }}>{totals.average}</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }

  // --- renderScoreInput* メソッドを追加 ---
  renderScoreInputObservationArea(item, itemOrg, obsIndex) { // 観察項目とその配下のスコアを描写
    type posScoreType = {
      position: string,
      score: string
    }
    const arrList: posScoreType[][] = []
    const arrOrgList: posScoreType[][] = []
    let idx = 0;
    if (item !== undefined) {
      while (idx < item.scores.length) {
        arrList.push(item.scores.slice(idx, idx + this.props.columnNum));
        idx = idx + this.props.columnNum;
      }
      idx = 0;
      while (idx < itemOrg.scores.length) {
        arrOrgList.push(itemOrg.scores.slice(idx, idx + this.props.columnNum));
        idx = idx + this.props.columnNum;
      }
      return (
        <div key={`observation_${obsIndex}`}>
          {/* <span style={{ fontSize: '20px', marginRight: '10px' }}>{item.observation}</span><br/> */}
          {/* <span style={{ fontSize: '20px', marginRight: '10px' }}>{this.props.observationDescriptions[obsIndex]}</span> */}
          <Table style={{ width: '100%' }}>
            <TableBody>
              {arrList.map((scoreRow, rowIndex) => this.renderScoreInputRowArea(scoreRow, arrOrgList[rowIndex], rowIndex, obsIndex))}
            </TableBody>
          </Table>
        </div>
      );
    } else {
      return null
    }
  }

  renderScoreInputRowArea(scoreRow, scoreRowOrg, rowIndex, obsIndex) {
    return (
      <TableRow key={`row_info_${obsIndex}_${rowIndex}`} style={{ margin: '0px' }}>
        {scoreRow.map((score, scoreIndex) => this.renderScoreInputArea(score, scoreRowOrg[scoreIndex], scoreIndex, rowIndex, obsIndex))}
      </TableRow>
    )
  }

  renderScoreInputArea(score, scoreOrg, scoreIndex, rowIndex, obsIndex) {
    const handleChange = () => {
      // 配列を複製する
      const scorIndex = rowIndex * this.props.columnNum + scoreIndex;
      const inputs = this.state.observationsScores.slice(); // observationsScoresを複製
      inputs[obsIndex].scores[scorIndex].score = String(Number(inputs[obsIndex].scores[scorIndex].score) + 1);
      if (Number(inputs[obsIndex].scores[scorIndex].score) > 6) {
        inputs[obsIndex].scores[scorIndex].score = '0';
      }
      this.setState({ observationsScores: inputs });
      if (this.state.observationsScores.length !== 0) {
        this.changeComprehensiveEvaluationTable();
      }
    }
    const styleButton = { padding: '0px', minWidth: '30px', minHeight: '15px', marginLeft: '5px' }
    return (
      <TableCell key={`score_info_${obsIndex}_${rowIndex}_${scoreIndex}`} style={(obsIndex % 2 === 0) ? styles.rowDark : styles.rowLight}>
        <span style={{ marginTop: '2px' }}>
          {score.position}:
        </span>
        <Button variant="contained" onClick={handleChange} style={styleButton} color={(score.score === scoreOrg.score) ? "default" : "secondary"}>
          {score.score}
        </Button>
      </TableCell>
    );
  }
  // --- ここまでメソッド追加 ---
}

export default KansatsuKirokuScoreEditForSubdiv;



// WEBPACK FOOTER //
// ./src/components/parts/KansatsuKirokuScoreEditForSubdiv.tsx